import UserGuide from '@/common/containers/Modals/UserGuide/UserGuide';

export default UserGuide;
